import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnatomicalSideLabelPipe, BaseLldTableComponent } from '../../../shared';


/**
* Limb Lenght Discrepancy table of PDF print.
*/
@Component({
	selector: 'prt-lld-table',
	templateUrl: './prt-lld-table.component.html',
	imports: [
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrtLldTableComponent extends BaseLldTableComponent { }
